import request from './handler'

const update = form => request.post('/projects/status', form)
export default {
  update
}
